import { useAppSelector } from "../Redux/store";

interface useAdminProps {}

export const useAdmin = () => {
    /* ******************** Hooks ******************** */
    const isAdmin = useAppSelector( state => state.Global.isAdmin);
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        isAdmin
    }
}